import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'

import ClearIcon from '@mui/icons-material/Clear'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import React from 'react'

interface SearchInputProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  onClearSearch: () => void
}

const SearchInput: React.FC<SearchInputProps> = ({ searchQuery, onSearchChange, onClearSearch }) => {
  return (
    <FormControl sx={{ m: 1, width: '30ch' }} variant='outlined' size='small'>
      <InputLabel htmlFor='search-input'>Search</InputLabel>
      <OutlinedInput
        id='search-input'
        value={searchQuery}
        autoComplete='off'
        endAdornment={
          <InputAdornment position='end'>
            {searchQuery ? (
              <IconButton
                edge='end'
                onClick={onClearSearch}
                aria-label='clear search'
                id='search-clear-button'
              >
                <ClearIcon />
              </IconButton>
            ) : (
              <SearchOutlinedIcon />
            )}
          </InputAdornment>
        }
        label='Search'
        type='text'
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </FormControl>
  )
}

export default SearchInput
